module.exports = __webpack_public_path__ + "img/dashboard-figure-left.a32ad89a.svg";